(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const checkbox = document.getElementById('check-23');
    const button = document.querySelector('.contact__button .button');

    if (!checkbox || !button) return;

    const toggle = () => {
      button.classList.toggle('selected', checkbox.checked);
    };

    toggle();
    checkbox.addEventListener('change', toggle);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', () => {
    const checkbox = document.querySelector('.newsletter-consent');
    const submitBtn = document.querySelector('.submit-email');

    if (!checkbox || !submitBtn) return;

    const toggleButton = () => {
      submitBtn.classList.toggle('enabled', checkbox.checked);
    };

    toggleButton();
    checkbox.addEventListener('change', toggleButton);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname === '/') {
      // Homepage

      const element = document.getElementsByClassName('header-wrapper')[0];
      element.style.position = 'absolute';

      // const navElements = document.querySelectorAll('.header__menu-item, .header__icon');
      document.getElementById('shaharHeader').style.background = 'transparent';
      document.getElementById('logowhite').style.display = 'block';
      document.getElementById('logoblack').style.display = 'none';
      // Change color on page load
      // navElements.forEach((item) => {
      //   item.style.color = 'white';
      // });

      // document.querySelectorAll('.header__menu-item, .header__icon').forEach((el) => {
      //   el.style.color = 'black';
      // });
    } else {
      // Not homepage
      const element = document.getElementsByClassName('header-wrapper')[0];
      element.style.position = 'sticky';

      const navElements = document.querySelectorAll('.header__menu-item, .header__icon');
      document.getElementById('shaharHeader').style.background = 'white';
      document.getElementById('logowhite').style.display = 'none';
      document.getElementById('logoblack').style.display = 'block';
      // Change color on page load
      navElements.forEach((item) => {
        item.style.color = 'black';
      });
    }
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      if (window.location.pathname === '/') {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
      }
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        document.getElementById('shaharHeader').style.background = 'white';
        document.getElementById('logowhite').style.display = 'none';
        document.getElementById('logoblack').style.display = 'block';
        const navElements = document.querySelectorAll('.header__menu-item, .header__icon');

        // Change color on page load
        navElements.forEach((item) => {
          item.style.color = 'black';
        });

        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        document.getElementById('shaharHeader').style.background = 'transparent';
        document.getElementById('logowhite').style.display = 'block';
        document.getElementById('logoblack').style.display = 'none';
        const navElements = document.querySelectorAll('.header__menu-item, .header__icon');

        // Change color on page load
        navElements.forEach((item) => {
          item.style.color = '';
        });
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shahar-links"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.swiper-icons', {
  slidesPerView: 'auto',
  spaceBetween: 30,
  freeMode: true,
  loop: true,
  autoplay: { delay: 2500, disableOnInteraction: false },
});

  } catch(e) { console.error(e); }
})();
})();
